export default "__VITE_ASSET__7B3YujYV__"